module.exports = __webpack_public_path__ + "static/media/16a.4fb4eb82.jpg";